const CONFIG = {};
CONFIG.sector_data_url = BASE_URL + '/data/sector/';
CONFIG.default_sector = 'advocacy';
CONFIG.city_data_url = BASE_URL + '/data/city/';
CONFIG.default_city = 'Campbell';
CONFIG.search_url = BASE_URL + '/data/orgs/';

CONFIG.minzoom = 9;
CONFIG.maxzoom = 18;
CONFIG.county_style = {fill: false, color: '#000', weight: 2};
CONFIG.city_style = {fill: '#295861', fillOpacity: 0.03, color: '#295861', weight: 1};

// how long is a "page" of results? See searchAndDownload()
CONFIG.pagination_page_size = 6;

const DATA = {};

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// INITIALIZATION: these functions are called when the page is ready,
///////////////////////////////////////////////////////////////////////////////////////////////////////////

$(document).ready(function () {
  // data initialization first, then the remaining init steps
  Promise.all([
      initData('./static/data/scc_boundary.geojson', 'json'),
      initData('./static/data/scc_cities.geojson', 'json'),
    ]).then(function(data) {
      initDataFormat(data)    // get data ready for use
      initChart();            // init the 'City by Sector' table with default data
      initCityDetails();      // init the 'City Details' panel with default city data
      initCityDetailsModal(); // init the 'City Details' modal
      initSearchForm();       // init the org listing search form
      initSearch();           // init the search function itself
      initDownloadButtons();  // init the behavior of the download buttons
      initOrgForm();          // init the form for submitting org info
      initMap();              // init the Leaflet map
      initTooltips();         // init the Tippy tooltips

      // kick things off with the full search
      submitSearch();

    }); // Promise.then()

})

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// FUNCTIONS CALLED ON DOC READY
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// Basic data init, returns a promise
function initData(url, type) {
  // wrap this in a promise, so we know we have it before continuing on to remaining initialize steps
  return new Promise(function(resolve, reject) {
    fetch(url).then(function(response) {
      if (type == 'csv') return response.text();
      if (type == 'json') return response.json();
    }).then(function(data) {
      resolve(data);
    });
  })
}

// Data formatting routines, to get the static, raw data files into the form we need it in
function initDataFormat(data) {
  // not a lot to do here, see initMap() for where these are added to the map
  DATA.county = data[0];
  DATA.cities = data[1];
}

function initChart() {
  // initialize the chart and add data for the default sector
  getChartData();

  // Get the chart container
  const container = document.querySelector('div#sector-chart div#chart');

  // init the chart itself
  CONFIG.chart = Highcharts.chart(container, {
    exporting: {
      enabled: true,
    },
    chart: {
        type: 'column',
      },
      title: {
        text: '', // updated at run time
        style: {
          fontFamily: 'Source Sans Pro',
            fontWeight: 700,
        },
      },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        // categories: cities, # updated at run time
        labels: {
          rotation: -60,
          style: {
            fontFamily: 'Source Sans Pro',
            fontSize: '14px',
            fontWeight: 400,
          },
        },
        title: {
          text: 'Location',
          style: {
            fontFamily: 'Source Sans Pro',
            fontSize: '14px',
            fontWeight: 400,
          },
        },
      },
      yAxis: {
        allowDecimals: false,
        title: {
          text: 'Number of Sector Measures',
          style: {
            fontFamily: 'Source Sans Pro',
            fontSize: '14px',
            fontWeight: 400,
          },
        },
      },
      // series data and name will be updated at run time
      series: [{ data: [], name: '' }], 
      plotOptions: {
        column: {
            color: '#295861',
        }
      }
  });


  // init the change listener on the sector dropdown
  $('div#sector-chart select').on('change', function() {
    const value = $(this).val();
    getChartData(value);
  });

}

function initCityDetails() {
  $('div#city-details-section select').on('change', function() {
    const value = $(this).val();
    getCityDetails(value);
  });

  // kick things off by getting city details and rendering the city detail panel
  getCityDetails(CONFIG.default_city);
}

function initCityDetailsModal() {
  // In addition to the City Details Card, there's a city details modal that opens when one clicks the full screen icon on the card
  $('div.city-details-card span.fa-expand').on('click', function() {
    updateCityDetailsModal(DATA.city_data);
    $('div#city-modal').modal('show');
  });
}

function initSearchForm() {
    // Init the MultiSelect on Sectors
    MultiSelect('checkboxset-sector', {
      allowSelectAll: false,
      selectedText: "chosen",
    });

    MultiSelect('checkboxset-city', {
      allowSelectAll: false,
      selectedText: "chosen",
    });

    // register change events on the search Multi-Selects
    // does not apply to the multi-select on the org submit form at the bottom
    $('body').on('change', 'fieldset.directory-search-fieldset input.search-input', function() {
      let checkbox = $(this);
      let checked = checkbox.is(':checked');
      let value = this.value;
      let text = checkbox.parent().text().trim();
      if (checked) {
        // show the "Clear All" button
        $('div#clear-all').addClass('d-flex');

        // add a pill
        $('<div>', {
          class: 'search-pill',
          value: value,
          html: `${text} <span data-value=${value} class="pill-close-x">&times;</span>`,
        }).appendTo($('div#search-pills'))
      } else {
        $(`div.search-pill[value="${value}"]`).remove();
        
        // Also remove the "clear all" pill if nothing is selected
        let checked = $('input:checkbox.search-input:checked').length;
        if ( checked == 0 && $('input#org-search').val() == '' ) {
          $('div#clear-all').removeClass('d-flex');
        }
      }
    });

    // register the close buttons on the pills themselves
    $('body').on('click', '.pill-close-x', function() {
      // uncheck the checkbox and update the state of the MultiSelect 
      let value = this.dataset.value;
      let checkbox = document.querySelector(`input[value=${value}]`);
      checkbox.checked = false;
      let event = new Event('change');
      checkbox.dispatchEvent(event);
      // remove the pill from the DOM
      $(`div.search-pill[value="${value}"]`).remove();
    });

    // Show/hide a clear-x button to the search input on blur
    $('input#org-search').on('blur', function() {
      if ($(this).val()) {
        $('.search-clear-x').show();
        // also show the "clear all" pill
        $('div#clear-all').addClass('d-flex');

      } else {
        $('.search-clear-x').hide();
        // Also remove the "clear all" pill if nothing is selected
        let checked = $('input:checkbox.search-input:checked').length;
        if ( checked == 0 ) {
          $('div#clear-all').removeClass('d-flex');
        }
      }
    });

    // clicking the clear-x on the search input, clears it.
    $('.search-clear-x').on('click', function() { 
      $('input#org-search').val('').trigger('change');
      $(this).hide();
      // Also remove the "clear all" pill if nothing is selected
      let checked = $('input:checkbox.search-input:checked').length;
      if ( checked == 0 ) {
        $('div#clear-all').removeClass('d-flex');
      }
    });

    // clicking the "Clear All" button clears existing search forms, pills and results, and triggers a search for everything
    // It also disables the "Download Filtered" button
    $('div#clear-all').on('click', function() {
      // clear all search pills
      $(this).removeClass('d-flex');
      $('div.search-pill').remove();

      // clear/update the MultiSelects
      $('input:checkbox.search-input').prop('checked', false);
      let checkboxes = document.querySelectorAll('input.search-input');
      let event = new Event('change');
      checkboxes.forEach(function(t) { t.dispatchEvent(event) });

      // clear the search input and hide the close-x 
      $('input#org-search').val('').trigger('change');
      $('span.search-clear-x').hide();
      submitSearch();

      // disable the "Filered Download" button
      $('button#download-filtered-orgs').prop('disabled', true);
    });

}

function initSearch() {
  $('button#search').on('click', function() {
    // ititial checks: is everything selected OR is everything unselected? If so, then there's no need to post a long list of things
    let all = $('input:checkbox.search-input').length;
    // let unchecked = $('input:checkbox.search-input:not(:checked)').length;
    let checked = $('input:checkbox.search-input:checked').length;

    if (( checked == all || checked == 0 ) && $('input#org-search').val() == '') {
      submitSearch();
    } else {
      // but wait! Because all checked is equivalent to all unchecked, 
      // we still need to verify each individual select is not all checked OR all unchecked
      let sectorall = $('input:checkbox[name="sector"]').length;
      let sectorchecked = $('input:checkbox[name="sector"]:checked').length;

      let locationall = $('input:checkbox[name="city"]').length;
      let locationchecked = $('input:checkbox[name="city"]:checked').length;

      if (( sectorall == sectorchecked || sectorchecked == 0 ) && ( locationall == locationchecked || locationchecked == 0 ) && $('input#org-search').val() == '')  {
        // nothing entered or checked or everything checked and nothing entered! 
        submitSearch();
      } else {
        // Okay! At least something is checked or unchecked, or there is something in the search input
        // set up the data object to be POST'ed
        let searchdata = getSearchData();

        // enable the Download Filtered Org button
        $('button#download-filtered-orgs').prop('disabled', false);

        // All set! Submit it
        submitSearch(searchdata);
      }
    }
  });
}

function initMap() {
    // init the map with some basic settings
    CONFIG.map = L.map('map',{
      minZoom: CONFIG.minzoom,
      maxZoom: CONFIG.maxzoom,
      keyboard: false,
      scrollWheelZoom: false,
      attributionControl: false,
      zoomControl: false,
    });

    L.Control.geocoder({
      position: 'topleft',
      collapsed: false,
      placeholder: 'Location Search',
    }).addTo(CONFIG.map);

    // create various panes to hold basemaps and vector layers
    CONFIG.map.createPane('basemap');
    CONFIG.map.getPane('basemap').style.zIndex = 600;
    CONFIG.map.getPane('basemap').style.pointerEvents = 'none';

    CONFIG.map.createPane('county');
    CONFIG.map.getPane('county').style.zIndex = 630;
    CONFIG.map.getPane('county').style.pointerEvents = 'none';

    CONFIG.map.createPane('city');
    CONFIG.map.getPane('city').style.zIndex = 635;
    CONFIG.map.getPane('city').style.pointerEvents = 'none';

    CONFIG.map.createPane('orgs');
    CONFIG.map.getPane('orgs').style.zIndex = 640;
    CONFIG.map.getPane('orgs').style.pointerEvents = 'none';

    CONFIG.map.createPane('labels');
    CONFIG.map.getPane('labels').style.zIndex = 650;
    CONFIG.map.getPane('labels').style.pointerEvents = 'none';

    // add the county boundary, and fit the map bounds to it
    let county = L.geoJSON(DATA.county, {
      pane: 'county',
      style: CONFIG.county_style,
    }).addTo(CONFIG.map);

    let homebounds = county.getBounds();

    CONFIG.map.fitBounds(homebounds, {
      paddingTopLeft: [0, 30],
    });

    new L.Control.ZoomBar({
      position: 'topright',
      homeBounds: homebounds,
    }).addTo(CONFIG.map);

    // add the city boundaries
    L.geoJSON(DATA.cities, {
      pane: 'county',
      style: CONFIG.city_style,
      onEachFeature: function(feature, layer) {
        layer.on('click', function(e) {
          handleMapCityClick(layer, e);
        });
      },
    }).addTo(CONFIG.map);

    // add a Voyager basemap, without labels
    var positron = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      pane: 'basemap',
    }).addTo(CONFIG.map);

    // then add positron labels to it
    L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_only_labels/{z}/{x}/{y}.png', {
      pane: 'labels',
      interactive: false, // allow clicks to pass through
    }).addTo(CONFIG.map);

    // add an empty feature group for holding org locations
    CONFIG.org_layer = L.featureGroup().addTo(CONFIG.map);

    // add custom attribution
    L.control.attribution({
      position: 'bottomright',
    }).addTo(CONFIG.map).addAttribution('Interactive mapping by <a href="https://www.greeninfo.org" target="_blank">GreenInfo Network</a>');
}

// Two organization download buttons, with different actions
// Note: The "Download City Data" button is simply a static link to a City XLS
function initDownloadButtons() {
  // This one is fairly easy: Get all org data as CSV
  $('button#download-all-orgs').on('click', function() {
    submitSearch(false, true);
  });

  // This one, we need to pass search params for filtering before producing the CSV
  $('button#download-filtered-orgs').on('click', function() {
    let searchdata = getSearchData();
    submitSearch(searchdata, true);
  });
}

// The form at the bottom of the page for submitting org info,
// this is protected by recaptcha
function initOrgForm() {

  // Init the MultiSelect on Sectors
  MultiSelect('checkboxset-sector-user', {
    allowSelectAll: false,
    selectedText: "chosen",
  });

  // reset the recaptcha token every 60 seconds - without this they time out after 2 minutes
  setInterval(function() { recaptcha_reset(); }, 60000);

  // define the submit action for the "Add Organization" form
  $('form#add-org').on('submit', function(e) {
    $('form#add-org .alert').hide();
    e.preventDefault();
    let data = new FormData(this);
    fetch('/organization/suggest/', {
      method: 'POST',
      body: data,
    }).then(function(response) {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response)
    }).then(function(json) {
      // Update the message alert on the form, either a "thanks" or a rejection by ReCaptcha
      if (json.success == 'success') {
        $('form#add-org .alert').removeClass('error').addClass('success').append(json.message).show();
      } else {
        $('form#add-org .alert').removeClass('success').addClass('error').append(json.message).show();
      }
    })
    .catch((error) => {
      console.log('Something went wrong.', error)
    })
    .finally(() => {
      // clean up: first reset the recpatcha token for the next submit
      recaptcha_reset();
      // and clear out the regular form fields 
      $('form#add-org input[type="text"]').val('');
    });  
  })
}

// init the Tippy tooltips
function initTooltips() {
  // not much to it...
  tippy('[data-tippy-content]', {
    trigger: 'click',
  });
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// NAMED FUNCTIONS
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// Submit the search. There are four distinct types, either we POST params and get filtered results back (JSON or CSV)
// or we GET full results back (JSON or CSV)
function submitSearch(searchparams=null, download=false) {
  if (!searchparams && download) {
    // GET a CSV with all data
    fetch(CONFIG.search_url, {
      method: 'GET',
      headers: {
        'content-type': 'text/csv;charset=UTF-8',
      },
    }).then(res => res.text())
      .then(function(res) {
        handleCSVResult(res);
      });

  } else if (searchparams && download) {
    // GET a filtered CSV
    fetch(CONFIG.search_url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'content-type': 'text/csv;charset=UTF-8',
      },
      body: JSON.stringify(searchparams)
    }).then(res => res.text())
      .then(function(res) {
        handleCSVResult(res);
      });
  
  } else if (searchparams && !download) {
    // POST the params, return JSON for display
    fetch(CONFIG.search_url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(searchparams)
    }).then(res => res.json())
      .then(function(res) {
        handleSearchResults(res);
      });
  
  } else if (!searchparams && !download) {
    // GET everything, returns JSON for display
    fetch(CONFIG.search_url)
      .then(res => res.json())
      .then(function(res) {
        handleSearchResults(res);
      });
  }
}

function handleSearchResults(results) {
  if (results.data.length) {
    $('div#nothing-found').hide();
    $('#results-message').show();
    $('div#org-cards-outer').show();
    updateMap(results.data);
    paginate(results);
  } else {
    // No results: update the results message
    $('#results-message').hide();
    $('div#nothing-found').show();
    $('div#org-cards-outer').hide();
    updateResults([]);
    // clear any result from the map
    updateMap([]);
  }
}

function paginate(results) {
  // alright then, go ahead and paginate it! 
  $('div#org-cards-outer').pagination({
    dataSource: results,
    locator: 'data', // needs to match the name of the returned data object
    pageSize: CONFIG.pagination_page_size,
    position: 'top',
    hideWhenLessThanOnePage: true,
    prevText: '<span class="sr-only">click to see the previous organizations</span><i class="fa-solid fa-chevron-left" aria-hidden="true"></i>',
    nextText: '<span class="sr-only">click to see the next organizations</span><i class="fa-solid fa-chevron-right" aria-hidden="true"></i>',
    callback: function(data, pagination) {
      // send this chunk of data to the org card grid
      updateResults(data, pagination); 

      // update the project counter
      if (data.length) {
        let start = (pagination['pageNumber'] - 1) * pagination['pageSize'] + 1;
        let end = pagination['pageNumber'] * pagination['pageSize'];
        if (end >= pagination['totalNumber']) end = pagination['totalNumber']; 
        let total = pagination.totalNumber;
        $('#results-message span#start-match').text(start);
        $('#results-message span#end-match').text(end);
        $('#results-message span#total-match').text(total);
      }
    }
  })
}

function handleMapOrgClick(layer, org) {
  // clear any existing selected class, and add it to this one 
  $('.org-icon').removeClass('selected');
  layer.getElement().classList.add('selected');

  let html = `<h4 class="org-title">${org.name}</h4>`;
     html += `<div class="org-type">${org.type}</div>`;
     html += `<div class="org-address-1">${org.street}</div>`;
     html += `<div class="org-address-2">${org.city}, ${org.state} ${org.zip}</div>`;
     html += `<div class="org-website"><a target="_blank" href="${org.website}">${org.website}</a> <i class="fa-solid fa-arrow-up-right-from-square"></i><span class="sr-only">(visit website, opens in a new tab, may not be accessible)</span></div>`;

  layer.bindPopup(html, {maxWidth: 245, minWidth: 200, autoPan: true, autoPanPaddingTopLeft: [5,110] }).openPopup();
}

function handleMapCityClick(layer, e) {
  let city = e.target.feature.properties['CITY'];

  const data = fetch(CONFIG.city_data_url + city).then(response => {
    if (response.ok) {
      response.json().then(city => {
        let html = `<h4 class="city-title">${city.cityname}</h4>`;
        
        if (city.reporting == 'N/A') {
          html += '<div class="city-link-name mt-1">Progress Reporting: <span>N/A</span>';
        } else {
          html += `<div class="city-link-name mt-1">Progress Reporting: <span><a target="_blank" href="${city.reporting}" title="Read more about this jurisdiction's progress reporting">Visit website</a> <i class="fa-solid fa-arrow-up-right-from-square"></i><span class="sr-only">(opens in a new tab, may not be accessible)</span></span></div>`;
        }

        if (city.cap_url == 'N/A') {
          html += '<div class="city-link-name">Link to CAP: <span>N/A</span>';
        } else {
          html += `<div class="city-link-name">Link to CAP: <span><a target="_blank" href="${city.cap_url}" title="Read more about this jurisdiction's climate action plan">Visit website</a> <i class="fa-solid fa-arrow-up-right-from-square"></i><span class="sr-only">(opens in a new tab, may not be accessible)</span></span></div>`;
        }        

        html += '<div class="ghg_targets mt-1"><span>GHG Reduction Targets: </span>';
        if (city.ghg_targets) {
          html += city.ghg_targets;
        } else {
          html += 'N/A';
        }

        html += '</div><hr>';
        html += '<div class="d-xl-table d-lg-table d-md-table d-block city-popup">';
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Responsible Dept.</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.department}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Sustainability Contact</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.contact}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Website</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value"><a target="_blank" href="${city.website}" title="Read more about this city">Visit website</a> <span class="fa-solid fa-arrow-up-right-from-square"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span></div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Email</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.email}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Phone</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.phone}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">CAP Adoption Year</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.cap_year}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Current CAP</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.current}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Qualified CAP</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.qualified}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">CAP Update in Progress</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.update}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Implementation Plan</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.implementation}</div></div>`;
        html += '<div class="d-xl-table-row d-lg-table-row d-md-table-row d-block"><div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-name">Adaptation element</div>';
        html += `<div class="d-xl-table-cell d-lg-table-cell d-md-table-cell d-block city-detail-value">${city.adaptation}</div></div>`;
        html += '</div>';

        // All set! Bind the html and open the popup
        layer.bindPopup(html, {maxWidth: 400, minWidth: 200, maxHeight: 365, autoPan: true, autoPanPaddingTopLeft: [5,110] }).openPopup();
      })
    } else {
      console.error('Could not load city data. Please try again.');
    }
  })
}

// construct an object containing search params from the selected search options and inputs
function getSearchData() {
  let searchdata = {};
  // add data for selected sectors and cities from the multiselects
  searchdata['sectors'] = $('input[name="sector"]:checked').map(function () {
    return this.value;
  }).get();
  searchdata['cities'] = $('input[name="city"]:checked').map(function () {
    return this.value;
  }).get();
  // add data for the search input for orgs
  searchdata['organization'] = $('input#org-search').val();

  return searchdata;
}

function handleCSVResult(content) {
  // Create a blob
  var blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  var url = URL.createObjectURL(blob);

  // Create a link to download it and click it
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'SCCCAP_organizations.csv');
  link.click();
}

function updateMap(data) {
  CONFIG.org_layer.clearLayers();

  data.forEach(function(org) {
    if (! org.latitude || ! org.longitude ) return;
    let marker = L.marker([org.latitude, org.longitude], {
      data: org,
      pane: 'orgs',
      keyboard: false,
      icon: L.divIcon({
        className: 'org-icon',
        html: `<div aria-label="Location of ${org.name}" data-lat="${org.latitude}" data-lng="${org.longitude}">`,
      })
    }).on('click', function(e) {
      handleMapOrgClick(e.target, this.options.data);
    }).addTo(CONFIG.org_layer);
  });
}

function updateResults(data) {
  $('div#search-results').show();
  let target = $('div#org-cards').empty(); 
  data.forEach(function(org) {
    // add a column for each org
    let col = $('<div>', {
      class: 'col col-md-6 col-xl-4 mb-4',
    }).appendTo(target);

    // then add card itself
    let card = $('<div>', {
      class: 'card',
    }).appendTo(col);

    // card body
    let body = $('<div>', {
      class: 'card-body',
    }).appendTo(card);

    // organization name
    $('<h4>', {
      class: 'org-title',
      text: org.name,
    }).appendTo(body);

    // organization type
    $('<div>', {
      class: 'org-type',
      text: org.type,
    }).appendTo(body);

    // description
    $('<div>', {
      class: 'org-description',
      text: org.description,
    }).appendTo(body);

    // sustainability list, conditional as sometimes there are none, sometimes there are multiples
    if (org.priority1) {
      // Sustainability header
      $('<div>', {
        class: 'sustainability-header',
        text: 'Sustainability Priorities',
      }).appendTo(body);
      
      // The list of priorities itself
      let list = $('<ol>', {
        class: 'sustainability-list',
      }).appendTo(body);

      // Sustainability priority 1
      [org.priority1, org.priority2, org.priority3, org.priority4, org.priority5].forEach(function(p) {
        if (p) {
          $('<li>', {
            text: p,
          }).appendTo(list);
        }
      })
    }

    $('<div>', {
      class: 'hr',
    }).appendTo(body);

    if (org.street) {
      $('<div>', {
        class: 'org-address-1',
        text: org.street,
      }).appendTo(body);

      $('<div>', {
        class: 'org-address-2',
        text: `${org.city}, ${org.state} ${org.zip}`,
      }).appendTo(body);
    }

    let table = $('<div>', {class: 'org-contact-info'}).appendTo(body);

    let row = $('<div>', {class: 'd-table-row'}).appendTo(table);
    $('<div>', {class: 'd-table-cell', text: 'Primary Contact'}).appendTo(row);
    $('<div>', {class: 'd-table-cell', text: org.contact}).appendTo(row);

    row = $('<div>', {class: 'd-table-row'}).appendTo(table);
    $('<div>', {class: 'd-table-cell', text: 'Email'}, {class: 'd-table-cell'}).appendTo(row);
    $('<div>', {class: 'd-table-cell', text: org.email}, {class: 'd-table-cell'}).appendTo(row);

    row = $('<div>', {class: 'd-table-row'}).appendTo(table);
    $('<div>', {class: 'd-table-cell', text: 'Geographic Area of Influence'}, {class: 'd-table-cell'}).appendTo(row);
    $('<div>', {class: 'd-table-cell', text: org.area}, {class: 'd-table-cell'}).appendTo(row);

    row = $('<div>', {class: 'd-table-row'}).appendTo(table);
    $('<div>', {class: 'd-table-cell', text: 'Funding Sources'}, {class: 'd-table-cell'}).appendTo(row);
    $('<div>', {class: 'd-table-cell', text: org.funding}, {class: 'd-table-cell'}).appendTo(row);

    if (org.website) {
      $('<div>', {
        class: 'org-website',
        html: `<a target="_blank" href="${org.website}" title="Read more about this organization">${org.website}</a> <span aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`,
      }).appendTo(body);
    }

    // Finally, format the results as a Masonry grid
    setTimeout(function() {
      new Masonry('.masonry', {
        itemSelector: '.col',
        percentPosition: true
      });
    },200)
  });
}

function getChartData(sector=CONFIG.default_sector) {
  const data = fetch(CONFIG.sector_data_url + sector).then(response => {
    if (response.ok) {
      response.json().then(data => {
        // update the chart
        // First get the city names from the data object, for the xAxis categories
        const cities = Object.keys(data);

        // Next get the values for each city within the data object, for the chart itself
        const datavalues = [];
        cities.forEach(function(c) {
          datavalues.push(Object.values(data[c])[0]);
        })

        // Next update the dynamic title with the formatted sector name
        sector = SECTOR_LOOKUP[sector];
        const title = `Number of ${sector} Sector Measures by Location`;

        // update and redraw
        CONFIG.chart.setTitle({text: title});
        CONFIG.chart.xAxis[0].update({categories: cities});
        CONFIG.chart.series[0].update({
          data: datavalues,
          name: `${sector} Sector`,
        });
        CONFIG.chart.redraw();
        // Hack: if we don't do this, and the data table is showing, 
        // then the table won't update with new data when we select another sector
        if ($('div.highcharts-data-table').is(':visible')) CONFIG.chart.viewData();
      })

    } else {
      console.error('Could not load sector data. Please try again.');
    }
  })
}

function updateCityDetailsCard(data) {
  const keys = Object.keys(data);
  keys.forEach(function(key) {
    let target = $(`div.city-details-card .city-detail-value[data-city-detail-value="${key}"]`);
    // several different content presentation types are possible here, e.g. HTML, Text, Links
    switch (key) {
      case 'ghg_targets': 
        target.html(data[key]);
        break;
      case 'website':
        let link = data[key];
        if (link == 'N/A') {
          target.text(link);
        } else {
          link = `<a target="_blank" title="Read more about this city" href="${link}">Visit website</a> <span class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`;
          target.html(link);
        }
        break;
      case 'cap_url':
        let capurl = data[key];
        if (capurl == 'N/A') {
          target.text('Link to CAP: N/A');
        } else {
          capurl = `<a target="_blank" href="${capurl}" title="Read more about this jurisdiction's climate action plan"><strong>Link to CAP</strong></a> <span class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`;
          target.html(capurl);
        }
        break;
      case 'reporting':
        let url = data[key];
        if (url == 'N/A') {
          target.text('Progress Reporting: N/A');
        } else {
          url = `<a target="_blank" href="${url}" title="Read more about progress reporting"><strong>Progress Reporting</strong></a> <span class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`;
          target.html(url);
        }
        break;

      default:
        target.text(data[key]);
    }
  });
}

function updateCityDetailsModal(data) {
  const keys = Object.keys(data);
  keys.forEach(function(key) {
    if (key == 'sectors') return; // see below
    let target = $(`div#city-modal .city-detail-value[data-city-detail-value="${key}"]`);
    // several different content presentation types are possible here, e.g. HTML, Text, Links
    switch (key) {
      case 'ghg_targets': 
        target.html(data[key]);
        break;
      case 'website':
        let link = data[key];
        if (link == 'N/A') {
          target.text(link);
        } else {
          link = `<a target="_blank" href="${link}" title="Read more about this city">Visit website</a> <span class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`;
          target.html(link);
        }
        break;
      case 'cap_url':
        let capurl = data[key];
        if (capurl == 'N/A') {
          target.text('Link to CAP: N/A');
        } else {
          capurl = `<a target="_blank" href="${capurl}" title="Read more about this jurisdiction's climate action plan">Link to CAP</a> <span class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`;
          target.html(capurl);
        }
        break;
      case 'reporting':
        let url = data[key];
        if (url == 'N/A') {
          target.text('Progress Reporting: N/A');
        } else {
          url = `<a target="_blank" href="${url}" title="Read more about this jurisdiction's progress reporting">Progress Reporting</a> <span class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></span><span class="sr-only">(opens in a new tab, may not be accessible)</span>`;
          target.html(url);
        }
        break;

      default:
        target.text(data[key]);
    }
  });

  // Sectors
  const target = $('div#city-modal table#city-modal-sectors tbody');
  data.sectors.forEach(function(row) {
    let tr = $('<tr>').appendTo(target);
    $('<td>', {
      text: row[0]
    }).appendTo(tr);
    $('<td>', {
      text: row[1]
    }).appendTo(tr);
    $('<td>', {
      text: row[2]
    }).appendTo(tr);
  });
}

function getCityDetails(city=DEFAULT_CITY) {
  const data = fetch(CONFIG.city_data_url + city).then(response => {
    if (response.ok) {
      response.json().then(json => {
        updateCityDetailsCard(json);
        // Keep a reference to the data, so we can use it later on the full screen modal
        DATA.city_data = json;
      })
    } else {
      console.error('Could not load city data. Please try again.');
    }
  })
}
